import React from 'react';

import {
  Avatar,
  Box,
  Chip,
  createStyles,
  Divider,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Typography,
  useTheme,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

interface Props {
  position: number;
  name: string;
  imageUrl?: string;
  score: number;
  isYou?: boolean;
  divider?: boolean;
  color?: string;
  dividerColor?: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: 0,
    },
    chip: {
      minWidth: 45,
    },
  }),
);

const LeaderboardListItem: React.FC<Props> = ({
  position,
  name,
  score,
  imageUrl,
  isYou = false,
  divider = false,
  color = 'text.disabled',
  dividerColor,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <ListItem className={classes.root}>
      <Box width="100%">
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          height={56}
          px={4}
          bgcolor={isYou ? theme.states.primary.outlinedHover : 'transparent'}
        >
          <Box display="flex" alignItems="center">
            <Box color={isYou ? 'text.primary' : color} textAlign="right" width={40} mr={4}>
              <Typography variant="subtitle1" component="span">
                {String(position).padStart(2, '0')}
              </Typography>
            </Box>
            <ListItemAvatar>
              <Avatar alt={name} src={imageUrl}>
                {name.substr(0, 1)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText>
              <Typography variant="body2">{name}</Typography>
              {isYou && (
                <Typography variant="body2" color="textSecondary">
                  <FormattedMessage id="game.details.leaderboard.you.label" />
                </Typography>
              )}
            </ListItemText>
          </Box>
          {score >= 0 && (
            <Chip
              className={classes.chip}
              label={score}
              color={isYou ? 'primary' : 'default'}
              size="small"
            />
          )}
        </Box>
        {divider && (
          <Box mx={4}>
            <Divider light style={dividerColor ? { backgroundColor: dividerColor } : undefined} />
          </Box>
        )}
      </Box>
    </ListItem>
  );
};

export default LeaderboardListItem;
